import YellowRule from '@/components/brand/YellowRule';

const AboutPage = () => (
  <div className="container-pd py-10 md:py-16" data-testid="about-page">
    <div className="max-w-3xl">
      <div className="font-mono text-[10px] text-[color:var(--pd-accent-yellow)] uppercase tracking-[0.2em]">About</div>
      <h1 className="font-display text-5xl md:text-7xl leading-[1.05] md:leading-none mt-3">Built by padel players. For padel players.</h1>
      <p className="mt-4 md:mt-6 text-base md:text-lg text-muted-sage">
        The Padel Draw is a UK-registered competition operator built to be a properly-run, trustworthy alternative to the raffle sites you already know. We wanted a place where the prizes are actually worth winning, the odds are honest, and every draw can be independently verified after the fact.
      </p>
      <p className="mt-3 md:mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-[color:var(--pd-gold)]" data-testid="about-motto">Equal Odds, Equal Opportunity.</p>
    </div>
    <YellowRule className="my-8 md:my-12" />
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
      {[
        { t: 'Why we built this', d: 'Because the prizes on generic competition sites are boring, and the sites themselves look like time-shares. We wanted prizes we actually want to win.' },
        { t: 'How we\u2019re different', d: 'Padel-specific prizes. Every draw is decided by a cryptographically-seeded RNG with a published audit trail, and additionally confirmed live by an independent witness. A free postal entry on every competition. And a proper, dark-themed site that doesn\u2019t insult you.' },
        { t: 'Where the money goes', d: '10% of our net profit goes to The Padel Foundation at the end of each financial year (year-end 31 March). Full details, and every contribution once made, live on our Giving Back page.' },
      ].map((c) => (
        <div key={c.t} className="bg-surface border border-pd rounded-2xl p-5">
          <h3 className="font-display text-xl md:text-2xl">{c.t}</h3>
          <p className="mt-2 md:mt-3 text-sm text-muted-sage">{c.d}</p>
        </div>
      ))}
    </div>
    <YellowRule className="my-8 md:my-12" />
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
      <div>
        <h2 className="font-display text-3xl md:text-4xl">Partners</h2>
        <p className="mt-3 md:mt-4 text-sm md:text-base text-muted-sage">We work with players and coaches from the UK padel community to source prizes people actually want.</p>
      </div>
      <div>
        <h2 className="font-display text-3xl md:text-4xl">Legal clarity</h2>
        <p className="mt-3 md:mt-4 text-sm md:text-base text-muted-sage">Competitions on this site are prize competitions, not lotteries. Every entry requires a skill question. Every competition offers a free postal entry route. Every draw is decided by a cryptographically-seeded random number generator whose seed and eligible ticket list are published for public recomputation, and is additionally confirmed live by an independent witness — both of these facts appear on the public draw record.</p>
      </div>
    </div>
  </div>
);

export default AboutPage;
